export default "__VITE_ASSET___vHNO4PE__";